import {CSSProperties} from "react";

/**
 * The marking of provisional values, such as incomplete months, proposed service periods or
 * forecasts. Tables and charts use the same hatching, so one legend explains both.
 */
export const PROVISIONAL_HATCH_STYLE: CSSProperties = {
    backgroundImage: 'repeating-linear-gradient(135deg, rgb(107 114 128 / 0.16) 0 1px, transparent 1px 6px)',
};
